import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../../utils/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isUserAuthenticated = isAuthenticated();

  const getStoredRole = () => {
    try {
      const rawUser = localStorage.getItem("user");
      if (!rawUser) {
        return null;
      }
      return JSON.parse(rawUser)?.role || null;
    } catch (error) {
      return null;
    }
  };

  if (!isUserAuthenticated) {
    sessionStorage.setItem(
      "redirectAfterLogin",
      `${location.pathname}${location.search}`
    );
    return <Navigate to="/login" replace />;
  }

  const profileComplete = localStorage.getItem("profileComplete");
  if (profileComplete === "false") {
    const role = getStoredRole();
    const defaultHomePath = role === "influencer" ? "/influencer" : "/";
    const isAllowedHomePath =
      location.pathname === "/" ||
      (role === "influencer" && location.pathname === "/influencer");

    if (!isAllowedHomePath) {
      return <Navigate to={defaultHomePath} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
